import { MEETING_FILTERS } from '../actions';

export default ( state = {}, action ) => {
	switch ( action.type ) {
		case MEETING_FILTERS:
			let filter_name = action.payload.key;
			let value = action.payload.value;
			let currentState = state;
			currentState[ filter_name ] = value;
			let newState = Object.assign( {}, currentState );
			return newState;
	}
	return state;
}